
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CelebrationIcon from '@mui/icons-material/Celebration';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import TtkList from './TtkList';
const DecoratorsTTK = ({ data }) => {
    return (
        <>
            <div className='row'>
                <div className='col-md-12'>
                    <div className='row mb-1'>
                        <div className='col-md-4'>
                            <p><WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Indoor Budget :</b>&nbsp;<span>&#8377; {data?.indoorBudget}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Outdoor Budget :</b>&nbsp;<span>&#8377; {data?.outdoorBudget}</span></p>
                        </div>
                    </div>
                    <div className='row mb-1'>
                        <div className='col-md-4'>
                            <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Decor Price (Home Function) :</b>&nbsp;<span>&#8377; {data?.homeFunction}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p><CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Decoration Type :</b>&nbsp;<TtkList data={data?.planningType} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p><LocationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Area of Working :</b>&nbsp;<TtkList data={data?.areaOfWork} /></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default DecoratorsTTK